import {getBotD6MinRoll} from "./getBotD6MinRoll";
import {BOT_PRESSURE_DICE_MIN_ROLL_BONUS} from "../../configs/botPressure";
import {checkIfBotPlayer} from "../players/checkIfBotPlayer";

const MAX_D6_MIN_ROLL = 6;

/**
 * Пол броска d6 бота в БОЮ (ближний бой и стрельба): к полу его уровня бонуса
 * (getBotD6MinRoll; у всех, кроме «божества», это 1) добавляется +1, если бой
 * идет против игрока под давлением ботов — алмаз и выше, оторвавшийся от
 * соперников (см. applyBotPressureLatches и src/configs/botPressure.js).
 *
 * Пол уровня бонуса в бою снимается, если среди противников есть бот (см.
 * checkIfAnyOpponentIsBot): кость урона «всегда 0» у божественного бота —
 * только против живых игроков и нейтральных отрядов. Давление при этом
 * действует, как у любого бота.
 *
 * Бот — по checkIfBotPlayer, одинаково у всех исполнителей броска при масках
 * движка ботов: ИИ-игрок на автопилоте (для движка isBot: true) давления не
 * получает, бот под ручным управлением админа (для движка isBot: false) —
 * получает.
 *
 * Прибавка именно к полу, а не к результату: диапазон грани кости не
 * ломается, механика та же, что у подкрутки уровнем бонуса. Между собой боты
 * кидают как раньше — признак берется только с защитника.
 *
 * Прибавка к самому значению — отдельный механизм поверх этого пола
 * (getBotD6RollBonus): ее передают в бросок вторым аргументом.
 *
 * @param {Object} rollingPlayer - владелец бросающего отряда
 * @param {Object|Object[]} targetPlayers - игрок-цель или все игроки, чьи
 *   отряды участвуют в этом бою на другой стороне (отряд в ближнем бою может
 *   быть зажат сразу несколькими противниками — хватает одного под давлением)
 */
export const getBotCombatD6MinRoll = (rollingPlayer, targetPlayers) => {
  const minRoll = getBotD6MinRoll(rollingPlayer, targetPlayers);

  if (!checkIfBotPlayer(rollingPlayer) || !targetPlayers) {
    return minRoll;
  }

  const targets = Array.isArray(targetPlayers) ? targetPlayers : [targetPlayers];
  const isAgainstPressuredPlayer = targets.some((target) => target && target.isUnderBotDicePressure);

  if (!isAgainstPressuredPlayer) {
    return minRoll;
  }

  return Math.min(MAX_D6_MIN_ROLL, minRoll + BOT_PRESSURE_DICE_MIN_ROLL_BONUS);
};
